module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.PostViewer #dl":{"hooks.onStartPrepareResponse":[{"value":function (res) {
if (fox.isArray(res) && res.length === 0) {
fox.Router.navigate('restricted');
return false;
}
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"~.PostViewer #dl","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/sitepage/restrictedContent.js
// module id = 689
// module chunks = 4